import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/shopryze/os-storefront-blue/src/app/collection/collection.tsx");
